import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  label: {
    position: 'inherit' as const,
    transform: 'none',
    marginBottom: '8px', // spacing(2) = 2 * 4px = 8px
  },
} satisfies Record<string, StyleEntry>;

export const getTextFieldSx =
  (letterSpacing = 0) =>
  (theme: Theme): SystemStyleObject<Theme> => ({
    '& label[data-shrink="false"] + .MuiInputBase-formControl .MuiInputBase-input::placeholder':
      {
        opacity: '0.45 !important',
        letterSpacing:
          letterSpacing > 0 ? theme.spacing(letterSpacing) : 'inherit',
      },
    '& .MuiInputBase-root': {
      letterSpacing:
        letterSpacing > 0 ? theme.spacing(letterSpacing) : 'inherit',
    },
  });
